import { Injectable } from '@angular/core';
import { Company } from '@core/models/company.model';
import { ActiveState, EntityState, EntityStore, StoreConfig } from '@datorama/akita';

export interface CompanyState extends EntityState<Company>, ActiveState {
  isClientInvestment: boolean;
}

@Injectable({ providedIn: 'root' })
@StoreConfig({ name: 'companies', resettable: true })
export class CompanyStore extends EntityStore<CompanyState> {
  constructor() {
    super();
  }
}
